// extracted by mini-css-extract-plugin
module.exports = {"remainingArticles":"ArticleGroup_remainingArticles__0PRLN","hidden":"ArticleGroup_hidden__uTHng"};